import { Api } from "./Api.class";
const endpoint = "suggest/locations";
const locationAPI = new Api(endpoint);
export default locationAPI;
